import Category from './Category.vue'
import MenuItem from "../../../core/components/menu/MenuItem";
import i18n from '../../../shared/i18n'

let routes = [
  {
    path: 'categories',
    component: Category,
    meta: {
      requiresAuth: true
    }
  }
];

export default {
  menuItem: new MenuItem('/categories', i18n.t('Categories'), 40, 'stream'),
  routes: routes
}
